import type { InputHTMLAttributes } from 'react';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  hint?: string;
  error?: string;
}

export function Input({ label, hint, error, className = '', ...rest }: Props) {
  return (
    <label className="block">
      {label && <span className="field-label">{label}</span>}
      <input
        {...rest}
        className={`field-input ${error ? 'border-red-400' : ''} ${className}`}
      />
      {hint && !error && <span className="block text-xs text-slate-500 mt-1">{hint}</span>}
      {error && <span className="block text-xs text-red-600 mt-1">{error}</span>}
    </label>
  );
}
